/// <amd-module name="typeahead/core/logging/Element" />

import {ISuggestionResult, Suggestion, SuggestionCategory} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";
import {ListItemType} from "../IListItem";

export class Element {
    private value: string = "";
    private mostRecentSelection: Optional<Suggestion> = Optional.empty<Suggestion>();
    private mostRecentInputValue: string = "";
    private essSuggestionCount: number = 0;
    private userHistorySuggestionCount: number = 0;
    private elementFocused: boolean = false;
    private readonly elementID: string;
    private suggestionShown: boolean = false;
    private suggestionSelected: boolean = false;
    private requestId: string = "";
    private egta: boolean = false;

    constructor(private domElementId: string = "") {
        if (domElementId) {
            this.value = $("#" + domElementId).val() || "";
            this.elementID = domElementId;
        }
    }

    public setElementFocused(): void {
        this.elementFocused = true;
        this.setMostRecentInputValue("");
    }

    public setSuggestionShown(suggestions: ISuggestionResult[], isEgta: boolean): void {
        this.egta = isEgta;
        this.suggestionShown = true;
        // Consider only the first level of suggestions for count
        if (!suggestions || !suggestions.length || suggestions[0].category !== "POPULAR") {
            this.setSuggestionCount(suggestions);
        }
    }

    public setSuggestionSelected(suggestion: Suggestion, requestId: string): void {
        this.suggestionSelected = true;
        this.mostRecentSelection = Optional.of(suggestion);
        this.value = suggestion.getDisplayText();
        this.requestId = requestId;
    }

    public setMostRecentInputValue(value: string): void {
        this.suggestionShown = false;
        this.userHistorySuggestionCount = 0;
        this.essSuggestionCount = 0;
        this.suggestionSelected = false;
        this.mostRecentInputValue = value;
        this.mostRecentSelection = Optional.empty<Suggestion>();
        this.value = value;
    }

    public isSuggestionShown(): boolean {
        return this.suggestionShown;
    }

    public isSuggestionSelected(): boolean {
        return this.suggestionSelected;
    }

    public getMostRecentInputValue(): string {
        return this.mostRecentInputValue;
    }

    public getEssSuggestionCount(): number {
        return this.essSuggestionCount;
    }

    public getMostRecentSelection(): Optional<Suggestion> {
        return this.mostRecentSelection;
    }

    public getVal(): string {
        return this.value;
    }

    public getElemId(): string {
        return this.elementID;
    }

    public getRequestId(): string {
        return this.requestId;
    }

    public isEgta(): boolean {
        return this.egta;
    }

    private setSuggestionCount(suggestions: ISuggestionResult[]): void {
        this.userHistorySuggestionCount = 0;
        this.essSuggestionCount = 0;
        if (suggestions) {
            suggestions.forEach((suggestionResult: ISuggestionResult) => {
                if (ListItemType.Label !== suggestionResult.listItemType) {
                    switch (suggestionResult.category) {
                        case SuggestionCategory[SuggestionCategory.USERHISTORY]: {
                            this.userHistorySuggestionCount++;
                            break;
                        }
                        case SuggestionCategory[SuggestionCategory.GEOLOCATION]: {
                            break;
                        }
                        case SuggestionCategory[SuggestionCategory.GOOGLEMAPS]: {
                            break;
                        }
                        default : {
                            this.essSuggestionCount++;
                        }
                    }
                }
            });
        }
    }
}
